import axios from 'axios';

// ----------------------------------------------------------------------
const getHost = () => {
  if (window.location.host.includes('localhost')) return 'http://admin.localhost:8000/api/v1';
  if (window.location.host.includes('sandbox')) return 'https://admin.sandbox.sowan.sa/api/v1';
  return 'https://admin.sowan.sa/api/v1';
};

const axiosInstance = axios.create({
  baseURL: getHost(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

const setSession = (token) => {
  if (token) {
    localStorage.setItem('token', token);
    axiosInstance.defaults.headers.Authorization = `Token ${token}`;
  } else {
    localStorage.removeItem('token');
    delete axiosInstance.defaults.headers.Authorization;
  }
};

const blobToBase64 = (blob) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

const exportRequest = async (url, params, filename) => {
  try {
    const response = await axiosInstance.get(url, { params, responseType: 'blob' });
    const objectURL = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = objectURL;
    link.setAttribute('download', `${filename}.csv`);
    link.click();
  } catch (error) {
    console.error(error);
  }
};

export { axiosInstance, setSession, exportRequest, blobToBase64 };
